require("../node_modules/swiper/dist/js/swiper");
require("../node_modules/swiper/dist/css/swiper.css");



// Create a slider for featured products (Monthly Specials)
module.exports = {
	// Slider for hero slides
	initHeroSlider: function() {
		new Swiper('.hero.swiper-container', {
			pagination: '.hero .swiper-pagination',
			paginationClickable: true,
			autoplay: 5000
		});
	},
	initSpecialsSlider: function() {
		return new Swiper('.featured-products .swiper-container', {
			pagination: '.featured-products .swiper-pagination',
			slidesPerView: 6,
			slidesPerGroup: 6,
			paginationClickable: true,
			lazyLoading: true,
			breakpoints: {
				1024: {
					slidesPerView: 4,
					slidesPerGroup: 4
				},
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				640: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					pagination: false,
					autoplay: 8000
				},
				320: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					pagination: false,
					autoplay: 8000
				}
			}
		});
	}
}



/*****************
 ** WEBPACK FOOTER
 ** ./js/slider.js
 ** module id = 6
 ** module chunks = 0
 **/